"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_designer_constants_1 = require("../../components/designer/form/form-designer.constants");
var form_card_model_1 = require("../../layout-models/form-models/form-card.model");
var layout_utils_1 = require("../layout-utils");
var form_card_cell_model_1 = require("../../layout-models/form-models/form-card-cell.model");
var FormNestedCardElement = /** @class */ (function () {
    function FormNestedCardElement(domInfo) {
        this.domInfo = domInfo;
    }
    FormNestedCardElement.prototype.onClone = function (designerContext) {
        var colCount = this.domInfo.getElemColumnCount();
        if (this.newNestedCard()) {
            this.domInfo.addClassToElem('form-designer__component--col-' + colCount);
        }
        else {
            // this.domInfo.addClassToElem('sis-form-builder__component--active');
            this.domInfo.addClassToElem('form-designer__component--col-' + colCount);
        }
    };
    FormNestedCardElement.prototype.onDrag = function (designerContext) {
        designerContext.showTrashBin = true;
    };
    FormNestedCardElement.prototype.onDrop = function (designerContext) {
        if (this.newNestedCardDropped()) {
            this.newNestedCardDropAction(designerContext);
        }
        else if (this.droppedNestedCardReOrdered()) {
            var cardId = this.domInfo.getDestinationCardId();
            var sourceCardId = this.domInfo.getSourceCardId();
            if (sourceCardId !== cardId) {
                this.handleNestedCardDropToOtherCard(cardId, sourceCardId, designerContext);
            }
            else {
                this.handleNestedCardReOrderInCard(cardId, designerContext);
            }
        }
        else if (this.nestedCardDeleted()) {
            var sourceCardId = this.domInfo.getSourceCardId();
            var cardSourceRowId = this.domInfo.getSourceRowId();
            var nestedCardId = this.domInfo.getControllerId();
            this.getCardAndDeleteItFromRow(sourceCardId, cardSourceRowId, nestedCardId, designerContext);
        }
    };
    FormNestedCardElement.prototype.onHover = function (designerContext) {
        if (this.domInfo.itemInTrash()) {
            // to review
            this.domInfo.addClassToElem('form-designer-mirror--trash');
            designerContext.itemInTrash = true;
        }
    };
    FormNestedCardElement.prototype.handleNestedCardDropToOtherCard = function (destinationCardId, sourceCardId, designerContext) {
        var cardSourceRowId = this.domInfo.getSourceRowId();
        var nestedCardId = this.domInfo.getControllerId();
        var reOrderedCard = this.getCardAndDeleteItFromRow(sourceCardId, cardSourceRowId, nestedCardId, designerContext);
        var rowWhereCardDropped = this.processNestedCardDropping(reOrderedCard, designerContext);
        designerContext.drawControllersOfNestedCard(destinationCardId, rowWhereCardDropped, reOrderedCard);
    };
    FormNestedCardElement.prototype.handleNestedCardReOrderInCard = function (cardId, designerContext) {
        var cardSourceRowId = this.domInfo.getSourceRowId();
        var nestedCardId = this.domInfo.getControllerId();
        var reOrderedCard = this.getCardAndDeleteItFromRow(cardId, cardSourceRowId, nestedCardId, designerContext);
        var rowWhereCardDropped = this.processNestedCardDropping(reOrderedCard, designerContext);
        designerContext.drawControllersOfNestedCard(cardId, rowWhereCardDropped, reOrderedCard);
    };
    FormNestedCardElement.prototype.newNestedCardDropAction = function (designerContext) {
        var cardId = this.domInfo.getDestinationCardId();
        var controllerRowId = this.domInfo.getDestinationRowId();
        var droppedItem = this.getDroppedNestedCard(cardId, controllerRowId, designerContext);
        if (droppedItem) {
            var droppedNestedCard = new form_card_model_1.FormCardModel();
            droppedNestedCard.isNested = true;
            droppedNestedCard.id = layout_utils_1.LayoutUtils.uniqueId();
            droppedItem.card = droppedNestedCard;
            droppedNestedCard.columnCount = 4;
            this.processNestedCardDropping(droppedNestedCard, designerContext);
            designerContext.nestedCardUpperRowModels.set(droppedNestedCard.id, []);
            droppedItem.checkedInLayout = true;
        }
    };
    FormNestedCardElement.prototype.processNestedCardDropping = function (droppedNestedCard, designerContext) {
        var cardId = this.domInfo.getDestinationCardId();
        var controllerRowId = this.domInfo.getDestinationRowId();
        var formCardToDropIn = this.getCardForNewFieldController(cardId, designerContext);
        var rowWhereCellDropped;
        if (this.domInfo.itemInRow()) {
            rowWhereCellDropped = formCardToDropIn.insertInRowOnIndex(form_card_cell_model_1.FormCardCellModel.cellWithCard(droppedNestedCard), controllerRowId, this.getIndexInRow(controllerRowId, droppedNestedCard, designerContext));
        }
        else if (this.domInfo.itemInUpperRow()) {
            rowWhereCellDropped = formCardToDropIn.insertInUpperRow(form_card_cell_model_1.FormCardCellModel.cellWithCard(droppedNestedCard));
            designerContext.newCreatedRowId = rowWhereCellDropped;
            var leaf = designerContext.cardUpperRowModels.get(cardId)[0];
            designerContext.rowBagModels.set(rowWhereCellDropped, [leaf]);
            designerContext.lowerRowBagModels.set(rowWhereCellDropped, []);
            designerContext.cardUpperRowModels.set(cardId, []);
        }
        else if (this.domInfo.itemInLowerRow()) {
            rowWhereCellDropped = formCardToDropIn.insertInLowerRow(form_card_cell_model_1.FormCardCellModel.cellWithCard(droppedNestedCard), controllerRowId);
            designerContext.newCreatedRowId = rowWhereCellDropped;
            var leaf = designerContext.lowerRowBagModels.get(controllerRowId)[0];
            designerContext.rowBagModels.set(rowWhereCellDropped, [leaf]);
            designerContext.lowerRowBagModels.set(controllerRowId, []);
            designerContext.lowerRowBagModels.set(rowWhereCellDropped, []);
        }
        return rowWhereCellDropped;
    };
    FormNestedCardElement.prototype.getDroppedNestedCard = function (cardId, controllerRowId, designerContext) {
        var newItem;
        if (this.domInfo.itemInUpperRow() &&
            designerContext.cardUpperRowModels.get(cardId)) {
            newItem = designerContext.cardUpperRowModels
                .get(cardId)
                .find(function (item) { return !item.checkedInLayout; });
        }
        else if (this.domInfo.itemInRow() &&
            designerContext.rowBagModels.get(controllerRowId)) {
            newItem = designerContext.rowBagModels
                .get(controllerRowId)
                .find(function (item) { return !item.checkedInLayout; });
        }
        else if (this.domInfo.itemInLowerRow() &&
            designerContext.lowerRowBagModels.get(controllerRowId)) {
            newItem = designerContext.lowerRowBagModels
                .get(controllerRowId)
                .find(function (item) { return !item.checkedInLayout; });
        }
        return newItem;
    };
    FormNestedCardElement.prototype.getIndexInRow = function (controllerRowId, droppedNestedCard, designerContext) {
        var indexInRow = 0;
        if (this.domInfo.itemInRow() &&
            designerContext.rowBagModels.get(controllerRowId)) {
            indexInRow = designerContext.rowBagModels
                .get(controllerRowId)
                .findIndex(function (item) { return !item.checkedInLayout; });
            if (indexInRow < 0) {
                indexInRow = designerContext.rowBagModels
                    .get(controllerRowId)
                    .findIndex(function (item) { return item.id === droppedNestedCard.id; });
            }
        }
        return indexInRow;
    };
    FormNestedCardElement.prototype.getFormCardById = function (cardId, designerContext) {
        var designerContentLayout = designerContext.layoutContent;
        var desiredCard;
        designerContentLayout.layoutRows.map(function (layoutRow) {
            if (!desiredCard) {
                desiredCard = layoutRow.cards.find(function (card) { return card.id === cardId; });
            }
        });
        return desiredCard;
    };
    FormNestedCardElement.prototype.getCardAndDeleteItFromRow = function (cardId, rowId, controllerId, designerContext) {
        var desiredCard = this.getFormCardById(cardId, designerContext);
        var result;
        var desiredRow = desiredCard.formCardRows.find(function (item) { return item.rowId === rowId; });
        var rowIndex = desiredCard.formCardRows.findIndex(function (item) { return item.rowId === rowId; });
        if (desiredRow) {
            var controllerIndex = desiredRow.cells.findIndex(function (item) { return item.id === controllerId; });
            result = desiredRow.cells.find(function (item) { return item.id === controllerId; })
                .card;
            desiredRow.cells.splice(controllerIndex, 1);
            if (desiredRow.cells.length === 0) {
                desiredCard.formCardRows.splice(rowIndex, 1);
            }
        }
        return result;
    };
    FormNestedCardElement.prototype.cardIndexInRowContainer = function (rowId, cardId, designerContext) {
        var rowBagControllers = designerContext.rowBagModels.get(rowId);
        return rowBagControllers.findIndex(function (item) { return item['id'] === cardId; });
    };
    FormNestedCardElement.prototype.newNestedCardDropped = function () {
        return (!this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER) &&
            !this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN));
    };
    FormNestedCardElement.prototype.nestedCardDeleted = function () {
        return (this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER) &&
            this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN));
    };
    FormNestedCardElement.prototype.droppedNestedCardReOrdered = function () {
        return (this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLERS_ROW_CONTAINER) &&
            !this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.CONTROLLER_TRASH_BIN));
    };
    FormNestedCardElement.prototype.getCardForNewFieldController = function (cardId, designerContext) {
        // will changed after first phase
        return designerContext.layoutCards.find(function (cardType) { return cardType.card.id === cardId; }).card;
    };
    FormNestedCardElement.prototype.newNestedCard = function () {
        return this.domInfo.elemIdEquals(form_designer_constants_1.FormDesignerConstants.NEW_NESTED_CARD_ID);
    };
    return FormNestedCardElement;
}());
exports.FormNestedCardElement = FormNestedCardElement;
//# sourceMappingURL=form-nested-card.element.js.map